/**
 * Utility to detect if the app is running as a microfrontend within a host
 */
export class MicrofrontendDetector {
  /**
   * Check if the app is running within an iframe (embedded as microfrontend)
   */
  static isEmbedded(): boolean {
    try {
      return window.self !== window.top;
    } catch (e: any) {
      // If we can't access window.top due to cross-origin restrictions,
      // we're likely in an iframe
      console.warn('Error while checking app running within an iframe: ', e);
      return true;
    }
  }

  /**
   * Check if the app is being loaded from the host domain
   */
  static isFromHost(): boolean {
    try {
      const referrer = document.referrer;
      const hostDomains = ['localhost:3000', 'portal.dpp.yara.com'];

      return hostDomains.some(domain => referrer.includes(domain));
    } catch (e: any) {
      console.warn(
        'Errror while checking app being loaded from the host domain: ',
        e
      );
      return false;
    }
  }

  /**
   * Check if app should run in microfrontend mode
   */
  static isMicrofrontend(): boolean {
    // Only consider it a microfrontend if both conditions are true:
    // 1. It's embedded in an iframe AND
    // 2. It's loaded from a host domain
    return this.isEmbedded() && this.isFromHost();
  }

  /**
   * Get the host URL if available
   */
  static getHostUrl(): string | null {
    try {
      const referrer = document.referrer;
      if (referrer.includes('localhost:3000')) {
        return 'http://localhost:3000';
      }
      if (referrer.includes('portal.dpp.yara.com')) {
        return 'https://portal.dpp.yara.com';
      }
      return null;
    } catch (e: any) {
      console.warn('Error while getting available host URL: ', e);
      return null;
    }
  }
}

export default MicrofrontendDetector;
